/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class UserSummaryDto {
  public id: string = undefined;
  public email: string = undefined;
  public name: string = undefined;
  public initials: string = undefined;
  public color: string = undefined;
}
